// extracted by mini-css-extract-plugin
export var calendar = "Calendar-module--calendar--38BrJ";
export var calendarPrimary = "Calendar-module--calendar--primary--32-ST";